import { h } from 'preact';
import { useState } from 'preact/hooks';
import clsx from 'clsx';
import CaretDown from '../utils/icon/caret-down.svg';

const MobileMenuList = ({ menuList, index, isVoyagesLayout }) => {
  const [opened, setOpened] = useState(false);
  return (
    <div
      key={index}
      className={`w-full laptop:w-auto border-b-[1px] ${
        isVoyagesLayout ? 'border-white-50' : 'border-black-30'
      } laptop:border-0`}
      style={{ order: menuList.index }}
    >
      <p
        className={`font-14-bold ${isVoyagesLayout ? 'text-white' : 'text-black'} laptop:mb-[13px] p-[21px] laptop:p-0 laptop:inline-block flex justify-between items-center`}
        onClick={() => setOpened(!opened)}
      >
        <span>{menuList.handle}</span>
        <CaretDown
          className={clsx('block laptop:hidden', opened && 'rotate-180')}
        />
      </p>
      <ul
        className={clsx(
          'overflow-hidden transition-all duration-300 px-[21px] laptop:px-0 [&_a]:font-14',
          isVoyagesLayout ? 'text-white' : 'text-charcoal',
          opened ? '!max-h-[1000px] mb-4' : 'max-h-0',
        )}
      >
        {menuList.links.length > 0 &&
          menuList.links.map((link) => (
            <li key={link.label} className="mb-5">
              <a href={link.url}>
                {link.label}
              </a>
            </li>
          ))}
        {menuList.url && (
          <li className="mb-5">
            <a href={menuList.url} className="underline">
              {window.TMW?.Strings?.header?.shopAll}
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default MobileMenuList;